import React from 'react';



const OtherBanner = (props) => {
    return (
        <section className="about-banner">
            <img src={props.image} alt="" className="w-100" />
            <div className="aboutBanner_text text-center">
                <div className="container c_container">
                    <div className="row">
                        <div className="col-12">
                            <h6 className="para-18 text-white">{props.title}</h6>
                            <h3 className="heading-1fff text-white">{props.text}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OtherBanner;